export default __webpack_public_path__ + "static/media/title.895cf40d.jpg";